import styled from 'styled-components'

import { ItemExpandable as DefaultItemExpandable } from 'components/Lists'

export const ItemExpandable = styled(DefaultItemExpandable)`
	margin-left: 16px;
	width: calc(100% - 24px);
`
